module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/thumbs_down-aa52fce1fff51d96d70e24bbacfc5bd2.svg";